import BigNumber from 'bignumber.js'
import { DEFAULT_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from 'config'

const options = {
  gasLimit: DEFAULT_GAS_LIMIT,
}

export const stakeMultiPool = async (multiPoolContract, amount) => {
  const value = new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString()
  const tx = await multiPoolContract.stakeDMD(value, options)
  const receipt = await tx.wait()
  return receipt.status
}

export const withdrawMultiPool = async (multiPoolContract, amount) => {
  const value = new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString()
  const tx = await multiPoolContract.withdraw(value, options)
  const receipt = await tx.wait()
  return receipt.status
}

export const getRewardMultiPool = async (multiPoolContract) => {
  const tx = await multiPoolContract.getReward(options)
  const receipt = await tx.wait()
  return receipt.status
}
